import SwiperCore, {
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Controller,
  Thumbs
} from "swiper";

import { Swiper, SwiperSlide } from "swiper/vue";
import "swiper/swiper-bundle.css";

SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Controller, Thumbs]);

export default {
  install: function(app /*, options*/) {
    app.component("swiper", Swiper).component("swiper-slide", SwiperSlide);
  }
};
